module.exports = __webpack_public_path__ + "img/contracts.cb95ee9a.svg";